// import { HttpInboundBillClientList } from '@/service/inbound';
import { HttpGetAllStaffList } from '@/service/department/departmentmanage.js'
import TableList from "@components/templates/tablelist";
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tabs: { show: true },
            formData: {
                search: {
                },
            },
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left"
            },
        };
    },
    methods: {
        ajaxRequest: HttpGetAllStaffList,
        handleOperates(data) {
            this.$emit('on-data', data)
        },
    },
    computed: {
        SearchsData() {
            return [
                {
                    label: "姓名",
                    key: 'CN_name',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "电话",
                    key: 'CN_phone',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "邮箱",
                    key: 'CN_mail',
                    show: true,
                    tag: 'vInput',
                },
            ]
        },
        columns() {
            return [
                {
                    title: "姓名",
                    key: 'name',
                },
                {
                    title: "电话",
                    key: 'phone',
                },
                {
                    title: "邮箱",
                    key: 'email',
                },
                {
                    title: "工号",
                    key: 'workno',
                },
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 90,
                    align: 'center',
                    render: (h, { row }) => {
                        return <vButton theme='primary' onClick={this.handleOperates.bind(this, row)}>{this.$t('fbb.inbound.choose', { defaultValue: '选择' })}</vButton>
                    }
                }];
        },
    },
};




